import moment from 'moment';
import styled, { useTheme } from 'styled-components';

import { min } from '../../../utils/breakpoints';
import futureInstruction from '../../../utils/futureInstruction';
import textOrPlaceholder from '../../../utils/textOrPlaceholder';
import ucFirst from '../../../utils/ucFirst';
import StyledTitle from '../../Styled/StyledTitle';

const Container = styled.div`
  margin-top: 24px;
`;

const Timestamp = styled.p`
  font-size: 14px;
  margin-bottom: 12px;
  text-align: center;

  ${min.sm} {
    text-align: left;
    font-size: 16px;
  }
`;

const BatteryInfo = styled.div`
  border: 1px solid ${(props) => props.theme.colors.light};
  border-radius: 8px;
  padding: 10px 16px;
  margin-bottom: 10px;

  ${min.sm} {
    display: flex;
    align-items: center;
  }
`;

const BatteryDetails = styled.div`
  flex: 1;
`;

const StatusText = styled.p`
  margin: 2px 0;
  font-size: 14px;
  text-align: center;

  ${min.sm} {
    text-align: left;
    font-size: 16px;
  }
`;

const RecentBatteryStatus = ({ latestRecord, lastInstruction, nextInstruction }) => {
  const lastRecordMoment = moment(latestRecord?.end_date * 1000);
  const batteryStatusText = futureInstruction(lastInstruction?.battery_update_command);
  const nextBatteryActionText =
    ucFirst(nextInstruction?.battery_update_command) +
    ` at ${moment
      .utc(nextInstruction?.target_datetime_utc * 1000)
      .local()
      .format('HH:mm')}`;

  const theme = useTheme();

  return (
    <Container>
      <StyledTitle>Most recent home battery status: </StyledTitle>
      <Timestamp>
        {textOrPlaceholder(
          latestRecord?.end_date,
          `${lastRecordMoment.format('DD/MM/YY [at] HH:mm')} (${lastRecordMoment.fromNow()})`
        )}
      </Timestamp>
      <BatteryInfo>
        <div className={'svg-icon battery-icon'}>
          <img src={theme.icons.battery} alt="Battery" />
        </div>
        <BatteryDetails>
          <StatusText>
            Battery status:{' '}
            <strong>{textOrPlaceholder(lastInstruction?.battery_update_command, batteryStatusText)}</strong>
          </StatusText>
          <StatusText>
            Battery state of charge:{' '}
            <strong>{textOrPlaceholder(latestRecord?.battery_soc, `${Math.floor(latestRecord?.battery_soc)}%`)}</strong>
          </StatusText>
          <StatusText>
            Next battery action:{' '}
            <strong>{textOrPlaceholder(nextInstruction?.battery_update_command, nextBatteryActionText)}</strong>
          </StatusText>
        </BatteryDetails>
      </BatteryInfo>
    </Container>
  );
};

export default RecentBatteryStatus;
